import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/Results/index.js";
const variants = import.meta.webpackContext("/components/Results", { recursive: true, regExp: /\.\/__variants__\/plp\-(?:curated\-category\-treatments\/allSizes|mweb\-image\-gallery\/v3)\/index\.js/ });
export default pointCut({ joinPoint, variants });